export default __webpack_public_path__ + "static/media/strategy3.09e9dbb3.png";